import React from 'react';
import { cn } from '../../utils/cn';

/**
 * The single count badge for sidebar nav items (Conflicting Vendors, Code Conflicts).
 * Both items render from this one component so their look, placement, 0-hiding and 99+
 * cap can never drift apart.
 *
 * - Renders nothing when count is 0/absent (never shows a "0").
 * - Caps the display at "99+".
 * - `label` (the nav item's name) drives an aria-label like
 *   "Code Conflicts, 147 items need attention".
 */
const NavBadge = ({ count, isCollapsed, label }) => {
  const n = Number(count) || 0;
  if (n <= 0) return null;

  return (
    <span
      role="status"
      aria-label={label ? `${label}, ${n} items need attention` : `${n} items need attention`}
      className={cn(
        'absolute bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center min-w-[18px]',
        isCollapsed
          ? 'top-0 right-0 w-4 h-4 translate-x-1 -translate-y-1'
          : 'right-2 px-1.5 py-0.5'
      )}
    >
      {n > 99 ? '99+' : n}
    </span>
  );
};

export default NavBadge;
